import { defineRouting } from 'next-intl/routing'
import { LOCALE_CODES, FALLBACK_LOCALE } from '@/lib/i18n/locales'

export const routing = defineRouting({
  // All 13 wiki languages — see src/lib/i18n/locales.js.
  locales: LOCALE_CODES,

  // Used when no locale matches
  defaultLocale: FALLBACK_LOCALE,
})
